import { render } from "./TemplateElement.vue?vue&type=template&id=ce8b04d6&scoped=true"
import script from "./TemplateElement.vue?vue&type=script&lang=js"
export * from "./TemplateElement.vue?vue&type=script&lang=js"

import "./TemplateElement.vue?vue&type=style&index=0&id=ce8b04d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8b04d6"]])

export default __exports__